module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iv",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 1986, 2007, 2020 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 2020")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("29 28 27 26 25 24 23 22 21 20    1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN-13: 978-0-226-68363-8 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-64393-9 (paper)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-64409-7 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("DOI: "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226644097.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226644097.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Le Frustrés—Intégral © DARGAUD BENELUX (DARGAUD-LOMBARD), by Bretécher, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.dargaud.com",
      "target": "_blank"
    }
  }, [_vm._v("www.dargaud.com")]), _vm._v(". All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Names: Becker, Howard Saul, 1928– author. | Richards, Pamela. Risk.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Writing for social scientists : how to start and finish your thesis, book, or article / Howard S. Becker ; with a chapter by Pamela Richards.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Other titles: Chicago guides to writing, editing, and publishing.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Third edition. | Chicago ; London : The University of Chicago Press, 2020. | Series: Chicago guides to writing, editing, and publishing | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2019031496 | ISBN 9780226683638 (cloth) | ISBN 9780226643939 (paperback) | ISBN 9780226644097 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: Social sciences—Authorship. | Sociology—Authorship. | Academic writing. | Communication in the social sciences.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC H61.8 .B43 2020 | DDC 808.06/63—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2019031496",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019031496")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v(" This paper meets the requirements of ANSI"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("/")]), _vm._v("NISO Z39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-054b55af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-becker-0005.vue
// module id = 66
// module chunks = 0